import React from "react";
import { Link } from "react-router-dom";

export function EditorialBanner({ title, subtitle, cta, link, image, align = "left", dark = true }) {
  return (
    <section className="relative w-full min-h-[60vh] md:min-h-[70vh] overflow-hidden">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className={`absolute inset-0 ${dark ? "bg-black/40" : "bg-white/30"}`} />

      <div className="relative z-10 flex items-end h-full min-h-[60vh] md:min-h-[70vh] px-6 md:px-16 pb-12 md:pb-20">
        <div className={`max-w-lg ${align === "right" ? "ml-auto text-right" : ""}`}>
          {subtitle && (
            <p className={`text-overline mb-3 ${dark ? "text-white/60" : "text-fashion-text-muted"}`}>
              {subtitle}
            </p>
          )}
          <h2 className={`font-display text-display-lg font-light mb-6 ${dark ? "text-white" : "text-fashion-text"}`}>
            {title}
          </h2>
          {cta && link && (
            <Link
              to={link}
              className={`btn-fashion ${dark ? "btn-fashion-white" : "btn-fashion-primary"}`}
            >
              {cta}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
